'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react/addons');

var _require = require('react-dnd');

var DragDropMixin = _require.DragDropMixin;
var NativeDragItemTypes = _require.NativeDragItemTypes;

/* Stores */
var ModuleInspectorStore = require('stores/module-inspector');
var LanguageStore = require('stores/language');

/* Components */
var TitledGroup = require('components/ui/titled-group');
var TextField = require('components/ui/text-field');

var ModuleInspectorPropertyTypeImage = React.createClass({
  displayName: 'ModuleInspectorPropertyTypeImage',

  mixins: [DragDropMixin],

  configureDragDrop: function configureDragDrop(registerType) {
    registerType(NativeDragItemTypes.FILE, {
      dropTarget: {
        acceptDrop: function acceptDrop(item) {
          if (item.files.length) {
            this._onImageDropped(item.files[0]);
          }
        }
      }
    });
  },

  componentDidMount: function componentDidMount() {
    // On first show - load image in background as the IMG element
    // is not visible, just a placeholder text.
    if (this.props.value && this.props.value.src) {
      var img = new Image();
      img.onload = this._onLoadComplete;
      img.onerror = this._onLoadError;
      img.src = this.props.value.src;
    }
  },

  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {

    // if (!prevProps.value && this.props.value || prevProps.value !== this.props.value && prevProps.value.src !== this.props.value.src) {
    //   let img = new Image()
    //   img.onload = component._onLoadComplete.bind(this)
    //   img.onerror = component._onLoadError.bind(this)
    //   img.src = this.props.value.src
    // }
  },

  render: function render() {
    var component = this;
    var cx = React.addons.classSet;
    var fileDropState = component.getDropState(NativeDragItemTypes.FILE);
    var props = component.props;

    var value = props.value;

    var emptyText = LanguageStore.translate('inspector_image_empty');
    var failedText = LanguageStore.translate('inspector_image_failed_to_load');
    var loadingText = LanguageStore.translate('inspector_image_loading');
    var titleText = ModuleInspectorStore.translate(props.groupName + '_' + props.name);

    var innerNode = null;

    if (value) {
      var src = '';
      if (value.data) {
        src = value.data;
      } else {
        src = value.src;
      }

      if (this.state.failed) {
        innerNode = React.createElement(
          'div',
          { className: 'empty' },
          failedText
        );
      } else if (this.state.loaded) {
        innerNode = React.createElement('img', { onLoad: component._onLoadComplete, onError: component._onLoadError, src: src });
      } else {
        innerNode = React.createElement(
          'div',
          { className: 'empty' },
          loadingText
        );
      }
    } else {
      innerNode = React.createElement(
        'div',
        { className: 'empty' },
        emptyText
      );
    }

    var classes = {};
    classes.image = true;
    classes.loaded = this.state.loaded;

    return React.createElement(
      TitledGroup,
      _extends({}, this.dropTargetFor(NativeDragItemTypes.FILE), { className: cx(classes), title: titleText }),
      innerNode
    );
  },

  _onLoadComplete: function _onLoadComplete(evt) {
    this.setState({ loaded: true });
  },

  _onLoadError: function _onLoadError(evt) {
    this.setState({ failed: true });
  },

  _onImageDropped: function _onImageDropped(file) {
    var _this = this;

    var component = this;
    var props = component.props;

    if (props.disabled) {
      return;
    }

    var type = file.type;

    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      var data = reader.result;

      var newValue = { type: type, data: data };

      if (props.onChange) {
        _this.setState({ failed: false, loaded: true });
        props.onChange(props.value, newValue);
      }
    };
  }
});

module.exports = ModuleInspectorPropertyTypeImage;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/type/image.js
 **/